import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FeedbackForm from "./components/FeedbackForm";
import { allCategories, allVideos } from "@/data/videos";
import usePageMeta from "@/hooks/usePageMeta";

const features = [
  {
    icon: "ri-movie-2-line",
    title: "品类齐全",
    text: "涵盖电影、电视剧、综艺、动画、纪录片与短视频六大类别，满足多样化观看需求。",
  },
  {
    icon: "ri-flashlight-line",
    title: "流畅体验",
    text: "简洁清晰的页面结构与筛选排序功能，让你更快找到想看的内容，减少无效浏览。",
  },
  {
    icon: "ri-magic-line",
    title: "智能推荐",
    text: "基于分类与标签的相关推荐，帮你在看完一部作品后快速发现更多同类精彩内容。",
  },
  {
    icon: "ri-shield-check-line",
    title: "用心呈现",
    text: "统一的界面风格与信息层级，兼顾桌面与移动端浏览体验，随时随地轻松追片。",
  },
];

export default function AboutPage() {
  const [open, setOpen] = useState(false);

  usePageMeta(
    "关于我们 - 免费视频网站91",
    "了解免费视频网站91 的网站定位、宗旨、联系方式与免责声明，我们致力于为用户提供丰富的免费高清视频内容。",
    "免费视频网站91,关于我们,免费视频,在线视频观看,免费高清视频",
  );

  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, []);

  const stats = [
    { value: `${allVideos.length}+`, label: "演示视频资源" },
    { value: `${allCategories.length}`, label: "内容分类" },
    { value: "每日", label: "持续更新" },
    { value: "免费", label: "在线观看" },
  ];

  return (
    <>
      <section className="border-b border-background-200/70 bg-background-100">
        <div className="container-page py-12 md:py-16">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-information-line"></i>
            关于我们
          </span>
          <h1 className="mt-4 font-heading text-3xl font-extrabold text-foreground-950 md:text-4xl">
            关于 免费视频网站91
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            免费视频网站91 是一个专注于提供免费高清在线视频资源的聚合平台，涵盖多种类别视频内容，
            致力于让每一位用户都能便捷地搜索、浏览、筛选与观看自己喜欢的视频，享受流畅而愉悦的观影过程。
          </p>
        </div>
      </section>

      <section className="container-page py-10 md:py-14">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-200/70 bg-background-50 p-4 text-center md:p-5"
            >
              <p className="font-heading text-2xl font-extrabold text-primary-600 md:text-3xl">
                {s.value}
              </p>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
              我们的定位
            </h2>
            <div className="mt-4 space-y-4 text-sm leading-relaxed text-foreground-600">
              <p>
                我们希望打造一个内容分类清晰、浏览路径通畅的在线视频门户。无论是想找一部放松身心的电影，
                还是想追一部热播剧集，亦或是利用碎片时间看看短片，都能在这里快速找到入口。
              </p>
              <p>
                通过多维度的筛选与排序、清晰的面包屑导航以及基于分类标签的相关推荐，
                我们尽量减少用户寻找内容的时间成本，把更多时间留给观看本身。
              </p>
              <p>
                同时我们持续优化桌面端与移动端的浏览体验，让你在任何设备上都能获得一致的顺手感受。
              </p>
            </div>
          </div>

          <div>
            <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
              我们提供什么
            </h2>
            <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="rounded-lg border border-background-200/70 bg-background-100 p-4"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">
                    {f.title}
                  </h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-500">{f.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="border-y border-background-200/70 bg-background-100">
        <div className="container-page py-10 md:py-14">
          <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
            联系方式
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-500">
            如果你有任何建议、内容反馈或合作意向，欢迎通过以下方式联系我们，我们会认真对待每一条留言。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <div>
                <p className="text-xs text-foreground-500">邮箱</p>
                <p className="text-sm font-semibold text-foreground-900">contact@video91.example</p>
                <p className="mt-0.5 text-xs text-foreground-400">演示联系方式，仅作展示</p>
              </div>
            </div>

            <div className="flex items-center justify-between gap-4 rounded-lg border border-background-200/70 bg-background-50 p-5">
              <div>
                <p className="text-xs text-foreground-500">反馈表单</p>
                <p className="text-sm font-semibold text-foreground-900">在线提交你的意见</p>
                <p className="mt-0.5 text-xs text-foreground-400">我们会尽快查看并回复</p>
              </div>
              <button
                type="button"
                onClick={() => setOpen(true)}
                className="inline-flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-chat-3-line"></i>
                填写反馈
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="container-page py-10 md:py-14">
        <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
          版权与免责声明
        </h2>
        <div className="mt-4 space-y-3 rounded-lg border border-background-200/70 bg-background-50 p-5 text-sm leading-relaxed text-foreground-600">
          <p>
            1. 本站当前为演示站点，页面中出现的全部视频标题、封面、简介、上传时间及播放量等数据均为演示示例数据，
            并非真实视频资源，也不代表任何真实作品或权利归属。
          </p>
          <p>
            2. 本站视频播放区域为前端演示控件，点击播放仅展示播放器交互效果，不提供真实视频流播放。
            如需上线真实播放能力，请接入合法合规的服务端视频源与相关授权。
          </p>
          <p>
            3. 本站尊重知识产权。若相关权利人对演示内容存在异议，可通过上方联系方式与我们沟通，
            我们将及时处理。
          </p>
          <p>
            4. 本演示站点仅用于展示产品设计与交互效果，不构成任何形式的商业服务承诺。
          </p>
        </div>

        <div className="mt-8">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-arrow-left-line"></i>
            返回首页继续浏览
          </Link>
        </div>
      </section>

      {open && (
        <div
          className="animate-fade-in fixed inset-0 z-50 flex items-center justify-center bg-foreground-950/50 p-4"
          onClick={() => setOpen(false)}
          role="presentation"
        >
          <div
            className="w-full max-w-lg rounded-lg border border-background-200 bg-background-50 p-6"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="反馈表单"
          >
            <div className="mb-4 flex items-start justify-between gap-4">
              <div>
                <h3 className="font-heading text-lg font-extrabold text-foreground-950">
                  提交反馈
                </h3>
                <p className="mt-1 text-xs text-foreground-500">
                  你的每一条建议，都会让免费视频网站91 变得更好。
                </p>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                aria-label="关闭"
                className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <FeedbackForm />
          </div>
        </div>
      )}
    </>
  );
}